module.exports = __webpack_public_path__ + "static/media/pack_cat_super_FR_768x350.015db83a.png";